// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h3W0y","expireSoon":"styles_expireSoon__2sYya"};